class StickyAtcs extends HTMLElement {
  constructor() {
    super();
    this.target = document.querySelector("pdp-journy");
    this.productOuter=document.querySelector(".product.row");
    this.btn = this.querySelector("button");
    this.handleScroll = this.handleScroll.bind(this);
    this.buttonContainer = this.querySelector("button").parentElement;
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkMobileScreen);
    
    this.btn.addEventListener("click", () => {
      console.log(this.productOuter);
      this.productOuter.scrollIntoView({ behavior: "smooth" });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.checkMobileScreen);
  }

  handleScroll() {
    const targetRect = this.target.getBoundingClientRect();
    if (targetRect.bottom < 0) {
      this.classList.remove('d-none');
    } else {
      this.classList.add('d-none');
    }
  }
}

window.customElements.define("sticky-atcs", StickyAtcs);
